import { render, staticRenderFns } from "./CreateTransfer.vue?vue&type=template&id=5cccafd0&scoped=true"
import script from "./CreateTransfer.vue?vue&type=script&lang=js"
export * from "./CreateTransfer.vue?vue&type=script&lang=js"
import style0 from "./CreateTransfer.vue?vue&type=style&index=0&id=5cccafd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cccafd0",
  null
  
)

export default component.exports